import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LiveChatStateService} from 'src/app/modules/live-chat/services/live-chat-state.service';
import { SessionService } from '../services/session.service';
import { environment } from 'src/environments/environment';
import {v4 as uuid} from "uuid";

@Injectable()
export class ConnectionInterceptor implements HttpInterceptor {

  constructor(
    private liveChatStateService: LiveChatStateService,
    private sessionService: SessionService
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith(environment.externalUrls.pegasus)) {
      return next.handle(request);
    }
    const headers = this.getConnectionIdHeader(request.headers);
    const newRequest = request.clone({headers});

    return next.handle(newRequest);
  }

  getConnectionIdHeader(headers: HttpHeaders) {
    let newHeaders = headers.append('Asksuite-Request-Id', uuid());
    if (this.liveChatStateService.currentSocketConnectionId) {
      newHeaders = newHeaders.append('Asksuite-Connection-Id', this.liveChatStateService.currentSocketConnectionId);
    }
    return newHeaders;
  }
}
